export default __webpack_public_path__ + "static/media/IBMDownloadWhite.512f80ae.svg";